import { useEffect, useState } from "react";
import { Instagram as IgIcon } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

interface InstagramProfileImageProps {
  src?: string | null;
  alt: string;
  className?: string;
  fallbackClassName?: string;
  iconClassName?: string;
}

const toProxyUrl = (url: string) =>
  `https://images.weserv.nl/?url=${encodeURIComponent(url.replace(/^https?:\/\//, ""))}`;

export const InstagramProfileImage = ({
  src,
  alt,
  className,
  fallbackClassName,
  iconClassName,
}: InstagramProfileImageProps) => {
  const [currentSrc, setCurrentSrc] = useState(src ?? "");
  const [usedProxy, setUsedProxy] = useState(false);
  const [failed, setFailed] = useState(!src);

  useEffect(() => {
    setCurrentSrc(src ?? "");
    setUsedProxy(false);
    setFailed(!src);
  }, [src]);

  return (
    <Avatar className={cn("bg-muted", className)}>
      {!failed && currentSrc ? (
        <AvatarImage
          src={currentSrc}
          alt={alt}
          referrerPolicy="no-referrer"
          crossOrigin="anonymous"
          className="object-cover"
          onError={() => {
            if (!usedProxy && src) {
              setCurrentSrc(toProxyUrl(src));
              setUsedProxy(true);
              return;
            }
            setFailed(true);
          }}
        />
      ) : null}
      <AvatarFallback className={cn("bg-muted text-muted-foreground", fallbackClassName)}>
        <IgIcon className={cn("h-1/2 w-1/2", iconClassName)} />
      </AvatarFallback>
    </Avatar>
  );
};
